import { render } from "./Prototypes.vue?vue&type=template&id=f0975044&scoped=true"
import script from "./Prototypes.vue?vue&type=script&lang=js"
export * from "./Prototypes.vue?vue&type=script&lang=js"

import "./Prototypes.vue?vue&type=style&index=0&id=f0975044&scoped=true&lang=css"

import exportComponent from "/home/runner/work/demo-webapp/demo-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0975044"]])

export default __exports__